<template>
    <v-row no-gutters>
    <v-col v-if="appStore.isCustomer" class="delayEl">
      <CustomerAlert />
    </v-col>
      <v-col v-else>
      <v-container class="px-md-0" fluid>
        <v-row dense>
          <v-col cols="12">
            <v-card
              color="birincil"
              rounded="pill"
              class="overflow-hidden d-flex px-3"
            >
              <v-icon class="ml-2" color="nightDark">{{ icons.mdiMagnify }}</v-icon>
              <v-text-field
                v-model="keyword"
                :label="title + ' ürünleri içinde arama yap'"
                rounded
                class="ml-n2"
                background-color="transparent"
                hide-details
                filled
                color="night"
                light
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-if="productsLoading" dense>
          <v-col v-for="product in 12" :key="product" cols="6" md="3" xl="2">
            <v-card rounded="xl" flat>
              <v-skeleton-loader height="565" type="image"></v-skeleton-loader>
            </v-card>
          </v-col>
        </v-row>
        <v-row v-else-if="productFilter.length == 0" dense>
          <v-col cols="12">
            <v-alert rounded="pill" prominent text type="warning"
              >Kayıt Bulunamadı</v-alert
            >
          </v-col>
        </v-row>
        <v-row v-else dense>
          <v-col
            v-for="(product, index) in productFilter"
            :key="product.id + '-' + index"
            cols="6"
            md="3"
            xl="2"
          >
            <order-card-modern
              :product="product"
              :index="index"
              @addInfo="addInfo"
            ></order-card-modern>
          </v-col>
        </v-row>

        <v-snackbars
          :messages.sync="snackbar"
          width="700"
          color="success"
          :timeout="3000"
          bottom
          right
          transition="slide-y-reverse-transition"
        >
          <template v-slot:default="{ message }">
            <div class="text-body-1 font-weight-bold">
              {{ message.product }}
            </div>
            <div>
              Ürününden
              <span class="text-body-1 font-weight-bold"
                >{{ message.qty }}

                {{
                  $store.state.tanimlar.birim.find(
                    (el) => el.value === message.birim
                  ).text
                }}</span
              >
              sepetinize eklendi
            </div>
          </template>
          <template v-slot:action="{ close }">
            <v-btn icon small @click="close()">
              <v-icon small>
                {{ icons.mdiClose }}
              </v-icon>
            </v-btn>
          </template>
        </v-snackbars>

      </v-container>
  </v-col>
  </v-row>
</template>
<script>
import { postData } from "@utils";
import store from "@/store";
import { useAppStore } from "@/stores/app";
import useAppConfig from "@core/@app-config/useAppConfig";
import { useRouter } from "@core/utils";
import CustomerAlert from "@/components/CustomerAlert.vue";
import {
  mdiCamera,
  mdiCameraOff,
  mdiChefHat,
  mdiClose,
  mdiCollage,
  mdiDelete,
  mdiEye,
  mdiEyeOff,
  mdiFilter,
  mdiFilterOff,
  mdiFlash,
  mdiMagnify,
  mdiMenuDown,
  mdiMenuUp,
  mdiPlusThick,
  mdiSquareEditOutline,
} from "@mdi/js";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import VSnackbars from "v-snackbars";
import Vue from "vue";
import OrderCardModern from "./OrderCardModern.vue";

export default {
  components: {
    OrderCardModern,
    VSnackbars,
    CustomerAlert,
  },
  setup(props, { emit }) {
    // Helpers
    const appStore = useAppStore();
    const { route, router } = useRouter();
    const PRODUCT_APP_STORE_MODULE_NAME = "app-order";

    // Register module
    if (!store.hasModule(PRODUCT_APP_STORE_MODULE_NAME)) {
      store.registerModule(PRODUCT_APP_STORE_MODULE_NAME, orderStoreModule);
    }

    // Page
    const userData = JSON.parse(localStorage.getItem("userData"));
    const pageLoading = ref(true);
    const userStatus = ref(false);
    onMounted(() => {
      if (userData.role === "PLSYR" && store.state.plasiyerCustomer === null) {
        userStatus.value = false;
      } else if (
        userData.role === "CUST" ||
        userData.role === "BAYI" ||
        userData.role === "SUBE"
      ) {
        userStatus.value = true;
      } else {
        userStatus.value = true;
      }
    });

    watch(
      () => store.state.plasiyerCustomer,
      () => {
        if (store.state.plasiyerCustomer) {
          userStatus.value = true;
        }
      }
    );


    // Title
    watch(
      () => route.value.params.type,
      () => {
        titleFn();
      }
    );

       // Müşteri seçimi gerekiyorsa değişiklikler izleniyor
    watch(
      () => appStore.selectedCustomer,
      () => {
        titleFn();
      }
    );

    onMounted(() => {
      titleFn();
    });

    const title = ref("");
    const titleIcon = ref("");

    const titleFn = () => {
      products.value = [];

      keyword.value = "";

      if (route.value.params.type === "ambalaj") {
        title.value = "Ambalaj";
        titleIcon.value = "mdiChefHat";
        fetchProducts(317);
      } else if (route.value.params.type === "ekipman") {
        title.value = "Ekipman";
        titleIcon.value = "mdiCollage";
        fetchProducts(318);
      } else if (route.value.params.type === "giyim") {
        title.value = "Giyim";
        titleIcon.value = "mdiCollage";
        fetchProducts(316);
      } else if (route.value.params.type === "hijyen") {
        title.value = "Hijyen";
        titleIcon.value = "mdiCollage";
        fetchProducts(315);
      } else if (route.value.params.type === "paketli") {
        title.value = "Paketli";
        titleIcon.value = "mdiCollage";
        fetchProducts(319);
      } else if (route.value.params.type === "siselenmis") {
        title.value = "Şişelenmiş";
        titleIcon.value = "mdiCollage";
        fetchProducts(314);
      } else if (route.value.params.type === "donuk") {
        title.value = "Donuk";
        titleIcon.value = "mdiCollage";
        fetchProducts(312);
      } else if (route.value.params.type === "taze") {
        title.value = "Taze";
        titleIcon.value = "mdiCollage";
        fetchProducts(313);
      }
    };

    const stokLoading = ref(false);

    postData({
      method: "getCategoryTree",
      baseCtg: 1,
    }).then((response) => {
      console.log(response);
    });

    // ————————————————————————————————————
    //* ——— Router
    // ————————————————————————————————————
    const { menuIsVerticalNavMini } = useAppConfig();

    const snackbar = ref([]);
    const categories = ref([]);
    const routeParams = computed(() => route.value.params);
    const products = ref([]);
    const productsLoading = ref(true);
    const loading = ref(false);

    const nextItem = ref(1);
    const categoryId = ref(0);

    // eslint-disable-next-line no-shadow
    const addInfo = (addInfo) => {
      snackbar.value.push(addInfo);
    };

    const fetchProducts = (type = 1, checkStock = 0) => {
      productsLoading.value = true;
      store
        .dispatch("app-order/fetchProducts", {
          method: "getProductsByCtgId",
          id: type || 1,
          checkStock,
          page: 1,
          count: 6,
          plant: "01",
        })
        .then((response) => {
          if (response.error) {
            Vue.swal({
              title: "Başarısız",
              text: response.msg,
              width: "350px",
              icon: "error",
              background: "#FF4C51",
              showCloseButton: false,
              showConfirmButton: true,
              confirmButtonColor: "#cc3d41",
            });

            router.push({ name: "dashboard" });

            return;
          }

          emit("changeStatus");

          products.value.push(...(response.detail?.products ?? []));
          stokLoading.value = false;
        })
        .finally(() => {
          productsLoading.value = false;
        });
    };

    const keyword = ref("");
    const productFilter = computed(() =>
      products.value.filter((product) =>
        keyword.value
          ?.toLowerCase()
          .split(" ")
          .every(
            (v) =>
              product.baslik.toLowerCase().includes(v) ||
              product.urun_kodu.toLowerCase().includes(v)
          )
      )
    );

    return {
      // Page
      userData,
      userStatus,
      pageLoading,

      // Title
      title,
      titleIcon,

      addInfo,
      snackbar,
      routeParams,
      fetchProducts,
      products,
      nextItem,
      categoryId,
      menuIsVerticalNavMini,
      productFilter,
      productsLoading,
      keyword,
      loading,
      categories,

      stokLoading,
      appStore,
      icons: {
        mdiMenuDown,
        mdiMenuUp,
        mdiCamera,
        mdiDelete,
        mdiCameraOff,
        mdiFlash,
        mdiEye,
        mdiEyeOff,
        mdiFilter,
        mdiFilterOff,
        mdiPlusThick,
        mdiSquareEditOutline,
        mdiClose,
        mdiMagnify,
        mdiChefHat,
        mdiCollage,
      },
    };
  },
};
</script>

<style lang="scss">
.siparis-tab-prd .v-tabs-slider-wrapper {
  display: none;
}

.siparis-tab-prd .v-tab {
  font-size: 11px !important;
  color: white !important;
  background-color: #3b3854 !important;
}
.siparis-tab-prd .v-tab--active {
  background-color: #0d6efd !important;
}
.siparis-hepsi-prd {
  .v-tab {
    background-color: #dfdfdf;
    min-width: initial !important;
    max-width: initial !important;
  }
  .v-slide-group__content {
    display: grid;
    grid-template-columns: repeat(5, 1fr);

    grid-column-gap: 1px;
    grid-row-gap: 1px;
    padding: 0px;
  }
}
@media screen and (max-width: 599px) {
  .siparis-tab-prd .v-tab {
    font-size: 11px !important;
    color: white !important;
    border-radius: 0px !important;
    background-color: #ff151a !important;
    box-shadow: none !important;
  }
  .siparis-tab-prd .v-tab--active {
    background-color: #0d6efd !important;
  }
  .siparis-hepsi-prd {
    .v-tab {
      background-color: #dfdfdf;
    }
    .v-slide-group__content {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-column-gap: 1px;
      grid-row-gap: 1px;
      padding: 0px;
    }
  }
}
.v-skeleton-loader__image {
  height: 100% !important;
}

.siparis-tab .v-tab {
  font-size: 11px !important;
  color: white !important;

  border-radius: 0px;
  // background-color: #3b3854 !important;
  background-color: #ff151a !important;
  box-shadow: rgba(0, 0, 0, 0.17) 0px -23px 25px 0px inset,
    rgba(0, 0, 0, 0.15) 0px -36px 30px 0px inset,
    rgba(0, 0, 0, 0.1) 0px -79px 40px 0px inset, rgba(0, 0, 0, 0.06) 0px 2px 1px,
    rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px,
    rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px;
}
.siparis-tab .v-tab--active {
  background-color: #0d6efd !important;
}
.siparis-hepsi {
  .v-tab {
    background-color: #dfdfdf;
  }
  .v-slide-group__content {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 1px;
    grid-row-gap: 1px;
    padding: 0px;

    // grid-column-gap: 1px;
    // grid-row-gap: 1px;
    // padding: 0px;
  }
}
@media screen and (max-width: 599px) {
  .siparis-tab .v-tab {
    font-size: 11px !important;
    color: white !important;
    border-radius: 0px !important;
    background-color: #ff151a !important;
    box-shadow: none !important;
  }
  .siparis-tab .v-tab--active {
    background-color: #0d6efd !important;
  }
  .siparis-hepsi {
    .v-tab {
      background-color: #dfdfdf;
    }
    .v-slide-group__content {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-column-gap: 1px;
      grid-row-gap: 1px;
      padding: 0px;
    }
  }
}
.satirVar {
  .v-toolbar__content {
    flex-direction: column;
    margin: 10px 0;
  }
}
</style>
